var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVegetativeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    viewBox: "0 0 6 104",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.1875L5.88675 -0.8125L0.113249 -0.8125L2.5 4.1875L3.5 4.1875ZM2.5 3.6875L2.50001 136.188L3.50001 136.187L3.5 3.6875L2.5 3.6875Z",
    fill: "#19A04B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVegetativeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vegetative_icon.46bbcde6c7ecd35b939c988dcc29fffa.svg";